<modal-container #modal [headerTitle]="'stock.positions.update'" [headerIconClass]="'fa-box'">
  <ng-container class="modal-button-show">
    <btn
      [icon]="'far-pencil'"
      [title]="'edit' | translate"
      [classes]="['btn-edit', 'btn-sm']"
      (onEvent)="showChildModal()"
    ></btn>
  </ng-container>
  <ng-container class="modal-body-content">
    <div class="card" style="padding: 26px" *ngIf="!!childModal?.childModal?.isShown">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      <div class="form-stock-load">
        <div class="row stock-positions" *ngIf="companyUtil.arePositionsEnabled">
          <div class="d-flex">
            <div class="col-12 col-sm-4 input-dash position-relative">
              <span class="stock-positions-absolute">{{ 'stock.positions' | translate }}</span>
              <form-row-input [label]="'row'" [icon]="'far-box'" [(model)]="position1"></form-row-input>
              <div class="align-self-center mt-2">-</div>
            </div>
            <div class="col-12 col-sm-4 input-dash">
              <form-row-input [label]="'aisle'" [icon]="'far-box'" [(model)]="position2"></form-row-input>
              <div class="align-self-center mt-2">-</div>
            </div>
            <div class="col-12 col-sm-4">
              <form-row-input [label]="'shelf'" [icon]="'far-box'" [(model)]="position3"></form-row-input>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 col-sm-6 pl-0">
            <form-row-input
              [label]="'purchasePrice'"
              [icon]="'fa-money-bill'"
              [(model)]="productDepot.purchasePrice"
              [replaceComma]="true"
              [currency]="productDepot.product.purchaseCurrency"
              [appendUnitCurrency]="true"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-6 pr-0">
            <form-row-select
              [label]="'supplier'"
              [icon]="'fa-truck'"
              [(model)]="productDepot.supplier.id"
              [options]="suppliers"
            ></form-row-select>
          </div>
        </div>
        <div class="row" *ngIf="product?.enabledBatchExpiration">
          <div class="col-12 col-sm-6 pl-0">
            <form-row-input
              [label]="'product.batch'"
              [icon]="'fa-cubes'"
              [(model)]="productDepot.batch"
              [inputType]="'text'"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-6 pr-0">
            <form-row-input
              [label]="'product.expirationDate'"
              [icon]="'fa-clock'"
              [model]="productDepot.expirationDate | fmtDate: 'yyyy-MM-dd'"
              (modelChange)="productDepot.expirationDate = $event"
              [inputType]="'date'"
            ></form-row-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 pl-0">
            <form-row-input
              [label]="'depot'"
              [icon]="'fa-industry'"
              [model]="productDepot.depot.name"
              [inputDisabled]="true"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-6 d-flex align-items-center justify-content-center mt-2 pr-0">
            <div class="availability-icons ml-auto">
              <div class="flex-gap-5 align-items-center">
                <div>
                  <i class="far fa-warehouse-alt"></i>
                </div>
                <div>
                  {{ stock.sumAll }}
                </div>
              </div>

              <div class="flex-gap-5 align-items-center">
                <div>
                  <i class="far fa-hourglass"></i>
                </div>
                <div>
                  {{ stock.sumReservations }}
                </div>
              </div>

              <div class="flex-gap-5 align-items-center">
                <div>
                  <i class="far fa-check"></i>
                </div>
                <div>
                  {{ stock.sumAvailable }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container class="modal-footer-content">
    <btn
      [label]="'save'"
      [icon]="'far-check'"
      [classes]="['btn-first']"
      (onEvent)="updatePosition()"
      [btnDisabled]="loading"
    ></btn>
  </ng-container>
</modal-container>
